/**
 * Actieve omgeving — bron van waarheid voor "welke lade kijk ik" — onthouden in
 * localStorage. Puur client-side; de server leidt de omgeving straks (stap 4) af uit
 * de identiteit en valideert 'm. De picker/wisselknop-UI is stap 7.
 */
const SLEUTEL = 'sass-rooster-omgeving';

// Waar we op terugvallen zolang er geen keuze is opgeslagen (nooit gekozen, of localStorage
// onbereikbaar). Hier geexporteerd zodat store, back-up-naam en import-check dezelfde bron
// delen: valt de een terug op arnhem_eo en de ander niet, dan wijst de bestandsnaam of de
// mismatch-melding naar een andere lade dan waaruit de data komt.
export const STANDAARD_OMGEVING = 'arnhem_eo';

/** Lees de opgeslagen actieve omgeving; null als er (nog) geen keuze of geen localStorage is. */
export function leesActieveOmgeving() {
  try {
    return localStorage.getItem(SLEUTEL);
  } catch {
    return null; // localStorage onbereikbaar (bv. private mode) -> geen opgeslagen keuze
  }
}

/** Sla de actieve omgeving op (no-op bij een lege sleutel of onbereikbare localStorage). */
export function zetActieveOmgeving(sleutel) {
  if (!sleutel) return;
  try {
    localStorage.setItem(SLEUTEL, sleutel);
  } catch {
    /* localStorage onbereikbaar -> stil; de keuze leeft dan alleen in het geheugen */
  }
}

/**
 * Pure keuze-helper (geen side-effects): welke omgeving is actief?
 * @param {Array<{ sleutel: string }>} omgevingen - beschikbare omgevingen uit wie-ben-ik.
 * @param {string|null} opgeslagen - eerder opgeslagen sleutel (leesActieveOmgeving()).
 * @returns {string|null} de opgeslagen sleutel als die nog beschikbaar is, anders de
 *   eerste beschikbare, anders null.
 */
export function kiesActieveOmgeving(omgevingen, opgeslagen) {
  const beschikbaar = Array.isArray(omgevingen) ? omgevingen.map((o) => o.sleutel) : [];
  if (opgeslagen && beschikbaar.includes(opgeslagen)) return opgeslagen;
  return beschikbaar[0] ?? null;
}
